export const ChatTemplate = ({ data, handler = () => {}, Css }) => {
  return (
    <div className={`border rounded-[10px] border-[#979797] flex w-full  bg-[#FFFFFF] h-[39px] shadow-sm overflow-hidden my-4 border-opacity-25 ${Css}`}>
      <div className="bg-[#D9FFCC] w-[8px] "></div>
      <div className="flex-1 w-full p-2 cursor-pointer" onClick={handler}>
        <div className="flex justify-between items-center">
          <h1 className="text-sm font-semibold text-nowrap text-ellipsis overflow-hidden">{data?.title}</h1>
        </div>
      </div>
    </div>
  );
};
